import React, { useState } from 'react';
import { storage } from '../../firebase';
import { ref, uploadBytesResumable, getDownloadURL, uploadBytes, } from "firebase/storage";

import Navbar from '../inc/Navbar';
import ScrollToTop from "react-scroll-to-top"
import { Link } from "react-router-dom";
import "./Conatct.css";




import { v4 as uuidv4 } from "uuid";
import { Contactformnew } from './ContactfromNew'
// import ExportContact from './ExportContact';


function Contact() {

  const [pdfFile, setPdfFile] = useState(null);
  const [downloadUrl, setDownloadUrl] = useState("");

  const [pdfUpload, setPdfUpload] = useState(null);
  const [PdfList, setPdfList] = useState([]);



  const handleUpload = async () => {
    if (!pdfFile) return alert("Please select a PDF file.");

    const fileRef = ref(storage, `pdfs/${pdfFile.name}_${uuidv4()}`);
    try {
      const snapshot = await uploadBytes(fileRef, pdfFile);
      const url = await getDownloadURL(snapshot.ref);
      setDownloadUrl(url);
      alert("PDF uploaded successfully!");
    } catch (err) {
      console.error("Upload error:", err);
      alert("Failed to upload PDF.");
    }
  };





  return (

    <>
      <Navbar />
      <br />
      <br />

      <br />

      <br>
      </br>
      <div className='websitedevelopkrishnagar'>
        <div className="album py-2">

          <div className="container mt-4">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Contact Us</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <ScrollToTop smooth top="100" color="Gray" />
      <div className="p-4 mb-2 bg-light text-dark">

      


        <div className="album py-0">

          <div className="container">

            <div className="row justify-content-center">

              <div className="col-md-5 mt-3" >


                <h6 className="card-text">MR. INDIAN CODER</h6>
                <p className="card-text mb-2">Company Profile</p>
                <p className="mb-1" ><small>Uniaone Save Family Services Pvt. Ltd.</small></p>
                <p className="mb-2" ><small>CIN: U85300WB2020PTC238719</small></p>


                <p className="card-text"> <br />Copyright © MR. INDIAN CODER</p>



                <div className="d-flex justify-content-between align-items-center">


                </div>

              </div>
              <div className="col-md-4 mt-3" >

                <h6 style={{ color: "Gray" }} className="card-text">For Contact</h6>
                <a href="tel: +91 9933798896" className="buttoncontact button3">    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward" viewBox="0 0 16 16">
                  <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z" />
                </svg> +91 9933798896</a>
                <br />


                <div className="d-flex justify-content-between align-items-center">

                </div>

              </div>
              <div className="col-md-3 mt-3" >
                <h6 style={{ color: "Gray" }} className="card-text " > <b>For business enquiry contact us at</b></h6>


                <a href='mailto: team@mrindiancoder.com'>team@mrindiancoder.com</a>


                <div className="d-flex justify-content-between align-items-center">

                </div>

              </div>
            </div>
          </div>
        </div>
        <br/>
 <div className="album py-0">

          <div className="container">
<h5 style={{color:"#126882"}} >For any updates or technical issues related to the website, please email us. Our team will address the matter with utmost care.</h5>
<p>Mail: <a href='mailto: team@mrindiancoder.com'> team@mrindiancoder.com</a></p>
</div>
</div>
        {/* <ExportContact month={6} year={2025} /> 


      <ExportFranchise month={6} year={2025} />  */}

        <br />





        {/* 
        <div>
          <h2>Upload a PDF File</h2>
          <input
            type="file"
            accept="application/pdf"
            onChange={(e) => setPdfFile(e.target.files[0])}
          />
          <button onClick={handleUpload}>Upload PDF</button>

          {downloadUrl && (
            <div>
              <p>PDF URL:</p>
              <a href={downloadUrl} target="_blank" rel="noopener noreferrer">
                View or Download PDF
              </a>
            </div>
          )}
        </div> */}
        <div className="album py-0">

          <div className="container">
            <div className='card'>
            
             
                <Contactformnew/>
              
            </div>
          </div>
        </div>
        <br/>
      </div>



    </>

  );
}

export default Contact;